export enum PaymentState {
    PRE_PAYMENT = 'PRE_PAYMENT',
    POST_PAYMENT = 'POST_PAYMENT',
    IN_PAYMENT = 'IN_PAYMENT'
}